import axios from 'axios';
import { API_BASE_URL, axiosConfig } from '../../config';
export const meetApi = axios.create({
  baseURL: `${API_BASE_URL}/meetings`,
  ...axiosConfig
});
export const meetingLink = code => `${window.location.origin}/join-meet/${code}`;
export async function copyText(text) {
  await navigator.clipboard.writeText(text);
}
